/**
 * Border radius preset mappings (key to px value).
 *
 * @type {Record<string, number>}
 */
export const BORDER_RADIUS_PRESETS = {
    square: 0,
    'slightly-rounded': 4,
    rounded: 8,
    pill: 24,
}

/**
 * Applies border radius preset from store settings to the theme.
 *
 * @param {import('@mui/material/styles').Theme} theme - The base MUI theme
 * @param {Object|null} storeSettings - Store customization settings
 * @returns {Object} Modified theme options object
 */
export const applyShape = (theme, storeSettings) => {
    const preset = storeSettings?.webStoreBorderRadius
    if (!preset || !(preset in BORDER_RADIUS_PRESETS)) {
        return theme
    }

    return {
        ...theme,
        shape: {
            ...theme.shape,
            borderRadius: BORDER_RADIUS_PRESETS[preset],
        },
    }
}
